// © Microsoft Corporation. All rights reserved.
/// <summary>Adds basic dom manipulation functions to an object defined as "dom"</summary>

import { canUseDOM } from "@msnews/isomorphic-util";

const doc = canUseDOM() ? document : null;
const otherWhitespaceRegex = /[\n\t]/g;
const trimRegex = /(^\s+)|(\s+$)/mg;

// curly brace needs to be on the return line otherwise build with throw an error
export default {
    attr: function (elem, attr) {
        // getAttribute(attr, 2) causes IE to only report correct values for href.
        // IE reports href values for IMG tags without an href property
        // see http://reference.sitepoint.com/javascript/Element/getAttribute
        // see bug #1131443
        return elem && (elem.getAttribute ? elem.getAttribute(attr, 2) : elem[attr]) || "";
    },
    name: function (elem) {
        return elem && elem.nodeName || "";
    },
    text: function (elem) {
        return (elem && (elem.textContent || elem.innerText) || "").replace(trimRegex, "");
    },
    children: function (elem) {
        return elem && elem.children || [];
    },
    parent: function (elem) {
        return elem && elem.parentNode;
    },
    getElementsByTagName: function (name) {
        return doc ? doc.getElementsByTagName(name) : [];
    },
    create: function (name) {
        return doc ? doc.createElement(name) : null;
    },
    containsClass: function (element, className) {
        /// <summary>
        /// Looks for the className in element and returns true/false based on result.
        /// <parameter>
        /// element - Element where className to be searched for.
        /// className - Class name to be looked for.
        /// </parameter>
        /// </summary>
        return element && ((" " + (element.className || element.getAttribute("class")) + " ")
            .replace(otherWhitespaceRegex, " ").indexOf(" " + className + " ") > -1);
    },
    getTarget: function (event) {
        return event && (event.customTarget || event.target || event.srcElement) || doc;
    }
};
